import router from '@/router';
import useUserStore from '@/store/modules/user';
import { ElMessageBox } from 'element-plus';

interface PageProps {
  //跳转页面路径
  path: string;
  // 跳转参数
  query?: Record<string, any>;
  // 是否需要新开页签跳转
  isBlank?: boolean;
  // 使用自定义方法:传该参数时，不会做跳转处理；
  callback?: () => void;
  // 登录状态下的回调(如果有的话)
  loginCallback?: () => void;
  // 未登录状态下的回调(如果有的话)
  notLoginCallback?: () => void;
}

export const checkLoginAndRedirect = ({
  path,
  query,
  callback,
  isBlank,
  loginCallback,
  notLoginCallback,
}: PageProps) => {
  const userStore = useUserStore();
  const isLoggedIn = Boolean(userStore.userId);
  const queryString = query ? `?${new URLSearchParams(query).toString()}` : '';
  const redirectUrl = `${path}${queryString}`;

  if (!isLoggedIn) {
    // 未登录的回调
    if (typeof notLoginCallback === 'function') {
      notLoginCallback();
    }

    ElMessageBox.confirm('您当前未登录，请登录后继续操作', '', {
      confirmButtonText: '立即登录',
      cancelButtonText: '暂不登录',
      type: 'info',
      customClass: 'login-required-dialog',
      cancelButtonClass: 'login-cancel-button',
      confirmButtonClass: 'login-confirm-button',
      center: true,
      showClose: true,
    })
      .then(() => {
        router.push({
          path: '/login',
          query: {
            redirect: encodeURIComponent(redirectUrl),
          },
        });
      })
      .catch(() => {
        // 暂不登录，不做任何处理
      });
  } else {
    // 登录的回调
    if (typeof loginCallback === 'function') {
      loginCallback();
    }

    if (typeof callback === 'function') {
      callback();
    } else if (isBlank) {
      window.open(redirectUrl, '_blank');
    } else {
      router.push({
        path,
        query,
      });
    }
  }
};
